module.exports = __webpack_public_path__ + "img/8.62a165a4.webp";